import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconInfoCircle = ({ id, color, width = 23, style, ...restProps }: IProps) => {
  const viewBoxWidth = 16;
  const viewBoxHeight = 17;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      width={`${width}px`}
      height={`${height}px`}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      fill="none">
      <path
        fill={iconColor}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.83333C11.676 1.83333 14.6667 4.824 14.6667 8.5C14.6667 12.176 11.676 15.1667 8 15.1667C4.324 15.1667 1.33333 12.176 1.33333 8.5C1.33333 4.824 4.324 1.83333 8 1.83333ZM8 0.5C3.582 0.5 0 4.082 0 8.5C0 12.918 3.582 16.5 8 16.5C12.418 16.5 16 12.918 16 8.5C16 4.082 12.418 0.5 8 0.5ZM7.99933 4.33333C8.45933 4.33333 8.83333 4.70667 8.83333 5.16667C8.83333 5.62667 8.45933 6 7.99933 6C7.53933 6 7.16667 5.62667 7.16667 5.16667C7.16667 4.70667 7.53933 4.33333 7.99933 4.33333ZM9.33333 12.5H6.66667V11.8333C6.98933 11.714 7.33333 11.6993 7.33333 11.3433V8.36533C7.33333 8.00933 6.98933 7.95333 6.66667 7.834V7.16733H8.66667V11.344C8.66667 11.7007 9.01133 11.716 9.33333 11.834V12.5Z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconInfoCircle;
